import { useEffect, useState } from "react";
import { http } from "../../lib/api";
import { fmtTL, fmtNum, fmtDate } from "../../lib/format";

const HEAD = [["Geçici Personel", "l"], ["TC", "l"], ["Şube", "l"], ["Kimin Yerine", "l"], ["Tarih Aralığı", "l"], ["Çalışma Gün", "r"], ["Yemek Gün", "r"], ["Günlük Tutar", "r"], ["Tutar", "r"]];
const cell = "px-3 py-1.5 text-xs";
const num = `${cell} numeric-cell`;

// Taşeron hakedişi detayında geçici personel bazında kırılım: kimin yerine, tarih aralığı, gün, anlaşılan günlük alış tutarı × gün (yemek/yol ayrımı yok)
export default function ClaimTempBreakdown({ inv, subcontractorId, testid }) {
  const [data, setData] = useState(null);
  const sub = inv.subcontractor_id || subcontractorId;
  useEffect(() => {
    if (!inv.project_id || !inv.period) { setData({ rows: [], totals: {}, people: 0 }); return; }
    http.get("/claims/history/temp-personnel", { params: { project_id: inv.project_id, period: inv.period, ...(inv.category_id ? { category_id: inv.category_id } : {}), ...(sub ? { subcontractor_id: sub } : {}) } })
      .then((r) => setData(r.data)).catch(() => setData({ rows: [], totals: {}, people: 0 }));
  }, [inv.project_id, inv.period, inv.category_id, sub]);
  if (!data) return <div className="px-3 py-2 text-[11px] text-slate-400 border-t border-slate-100">Geçici personel kırılımı yükleniyor…</div>;
  const t = data.totals || {};
  return (
    <div className="border-t-2 border-sky-200" data-testid={testid}>
      <div className="px-3 py-1.5 bg-sky-50 flex flex-wrap items-center justify-between gap-2">
        <span className="text-[10px] uppercase tracking-wider font-bold text-sky-900">Geçici Personel Kırılımı <span className="ml-1 font-normal normal-case text-sky-700">(görev bazında · anlaşılan günlük tutar × çalışma günü; yemek / yol ayrımı yok)</span></span>
        <span className="text-[10px] text-sky-800" data-testid={`${testid}-summary`}>{data.people} geçici personel · {data.rows.length} görev · {fmtNum(t.work_days)} gün · {fmtTL(t.total)}</span>
      </div>
      <div className="overflow-x-auto">
      <table className="w-full tbl">
        <thead><tr className="bg-white">{HEAD.map(([h, a]) => <th key={h} className={`px-3 py-1.5 text-[10px] uppercase tracking-wider text-slate-500 font-semibold ${a === "r" ? "text-right" : "text-left"}`}>{h}</th>)}</tr></thead>
        <tbody>
          {data.rows.map((r) => (
            <tr key={r.assignment_id} className="border-t border-slate-100" data-testid={`${testid}-row-${r.assignment_id}`}>
              <td className={`${cell} font-semibold text-slate-900`}>{r.full_name}</td>
              <td className={`${cell} font-mono text-slate-500`}>{r.tc_masked || "—"}</td>
              <td className={cell}>{r.location_name || "—"}</td>
              <td className={cell}>{r.replaced_name || "—"}{r.replaced_leave_type && <div className="text-[9px] text-slate-400">{r.replaced_leave_type}</div>}</td>
              <td className={`${cell} whitespace-nowrap`}>{fmtDate(r.start_date)} – {fmtDate(r.end_date)}</td>
              <td className={num}>{fmtNum(r.work_days)}</td>
              <td className={num}>{fmtNum(r.meal_days)}</td>
              <td className={num}>{fmtTL(r.unit_price)}</td>
              <td className={`${num} font-bold text-slate-900`}>{fmtTL(r.total)}</td>
            </tr>
          ))}
          {data.rows.length === 0 && <tr><td colSpan={9} className="px-3 py-2 text-xs text-slate-400">Bu dönem / ana hizmet için bu taşerona ait geçici personel görevi yok</td></tr>}
        </tbody>
        {data.rows.length > 0 && (
          <tfoot className="bg-sky-50/60 border-t border-sky-200">
            <tr data-testid={`${testid}-total`}>
              <td colSpan={5} className="px-3 py-1.5 text-[10px] font-bold text-sky-900 uppercase tracking-wider">Toplam</td>
              <td className={`${num} font-bold`}>{fmtNum(t.work_days)}</td>
              <td className={`${num} font-bold`}>{fmtNum(t.meal_days)}</td>
              <td className={`${num} text-slate-500`}>{t.work_days ? `ort. ${fmtTL(t.total / t.work_days)}` : "—"}</td>
              <td className={`${num} font-bold text-sky-900`}>{fmtTL(t.total)}</td>
            </tr>
          </tfoot>
        )}
      </table>
      </div>
    </div>
  );
}
